import { withTheme } from '@mui/styles';
import { connect } from 'react-redux';
import CallList from './CallList';
const mapStateToProps = ({ scribeConversation: { status } }) => ({ status });
export default withTheme(connect(mapStateToProps, {})(CallList));
